import React from "react";

import { Button } from "aible";

import { LineInput } from "components/Inputs/LineInput";
import AibleStep from "containers/CreateWizard/AibleStep";
import CostsSliderContainer from "containers/CreateWizard/Costs/CostsSlider";

import Slider from "rc-slider";

import styles from "./style.module.css";

export default class ContinuousImpacts extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isSlider: false
    };
  }

  handleUpdateSlider(step) {
    const { updateConversionGain, updateConversionCost, updateConversionMissed, updateConversionSaved } = this.props;

    if (step === 0) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(10);
      updateConversionCost(-10);
    } else if (step === 1) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(5);
      updateConversionCost(-5);
    } else if (step === 2) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(2);
      updateConversionCost(-2);
    } else if (step === 3) {
      updateConversionGain(1);
      updateConversionMissed(-1);
      updateConversionSaved(1);
      updateConversionCost(-1);
    } else if (step === 4) {
      updateConversionGain(2);
      updateConversionMissed(-2);
      updateConversionSaved(1);
      updateConversionCost(-1);
    } else if (step === 5) {
      updateConversionGain(5);
      updateConversionMissed(-5);
      updateConversionSaved(1);
      updateConversionCost(-1);
    } else if (step === 6) {
      updateConversionGain(10);
      updateConversionMissed(-10);
      updateConversionSaved(1);
      updateConversionCost(-1);
    }
  }

  calculateStep() {
    const { conversionGain, conversionCost } = this.props;

    let step = 0;

    if (conversionGain === 1 && conversionCost === -10) {
      step = 0;
    } else if (conversionGain === 1 && conversionCost === -5) {
      step = 1;
    } else if (conversionGain === 1 && conversionCost === -2) {
      step = 2;
    } else if (conversionGain === 1 && conversionCost === -1) {
      step = 3;
    } else if (conversionGain === 2 && conversionCost === -1) {
      step = 4;
    } else if (conversionGain === 5 && conversionCost === -1) {
      step = 5;
    } else if (conversionGain === 10 && conversionCost === -1) {
      step = 6;
    }

    return step;
  }

  renderSlider() {
    const { id, isContinuous, outcome, success, options } = this.props;
    const { isSlider } = this.state;

    const marks = isContinuous
      ? {
          0: "Impact of Underestimate ≥ 10x Impact of Overestimate",
          1: "Impact of Underestimate ≥ 5x Impact of Overestimate",
          2: "Impact of Underestimate ≥ 2x Impact of Overestimate",
          3: "Impact of Overestimate = Impact of Underestimate",
          4: "Impact of Overestimate ≥ 2x Impact of Underestimate",
          5: "Impact of Overestimate ≥ 5x Impact of Underestimate",
          6: "Impact of Overestimate ≥ 10x Impact of Underestimate"
        }
      : {
          0:
            "The Cost of incorrectly predicting when '" +
            outcome +
            " = " +
            success +
            "' is > 10 times the Benefit of getting it right",
          1:
            "The Cost of incorrectly predicting when '" +
            outcome +
            " = " +
            success +
            "' is > 5 times the Benefit of getting it right",
          2:
            "The Cost of incorrectly predicting when '" +
            outcome +
            " = " +
            success +
            "' is > 2 times the Benefit of getting it right",
          3:
            "The Benefit of correctly predicting when '" +
            outcome +
            " = " +
            success +
            "' is equal to the Cost of getting it wrong",
          4:
            "The Benefit of correctly predicting when '" +
            outcome +
            " = " +
            success +
            "' is > 2 times the Cost of getting it wrong",
          5:
            "The Benefit of correctly predicting when '" +
            outcome +
            " = " +
            success +
            "' is > 5 times the Cost of getting it wrong",
          6:
            "The Benefit of correctly predicting when '" +
            outcome +
            " = " +
            success +
            "' is > 10 times the Cost of getting it wrong"
        };

    const step = this.calculateStep();

    const isLocked = options && options["lock"];

    return (
      <div
        className={styles.sliderBody + " " + styles.transitionHolder}
        style={{ maxHeight: isSlider ? "100px" : "0px" }}
      >
        <div className={styles.sliderValue}>{marks[step]}</div>
        <div className={styles.sHolder}>
          <div className={styles.cost} style={{ paddingRight: "10px" }}>
            {isContinuous ? "Under" : "Cost"}
          </div>
          <Slider
            min={0}
            max={6}
            value={step}
            dots={true}
            onChange={isLocked ? () => {} : (val) => this.handleUpdateSlider(val)}
            className={styles.sliderHolder}
          />
          <div className={styles.cost} style={{ paddingLeft: "10px" }}>
            {isContinuous ? "Over" : "Benefit"}
          </div>
        </div>
      </div>
    );
  }

  renderHelpSlider() {
    const { isShow } = this.props;

    return (
      <div className={styles.dataBody} style={{ opacity: isShow === true ? 1 : 0 }}>
        {this.renderSlider()}
      </div>
    );
  }

  renderNormal() {
    const {
      id,
      step,
      blueprintId,
      isAdvanced,
      isEditing,
      isSimpleCosts,
      isShow,
      customvalues,
      overestimateLabel,
      underestimateLabel,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      customValues,
      outcome,
      options,
      updateOverestimateLabel,
      updateUnderestimateLabel,
      updateConversionGain,
      updateIsAdvanced,
      updateConversionCost,
      hideExtra,
      noEdit
    } = this.props;

    const isLocked = options && options["lock"];

    return (
      <div className={styles.outerHolder}>
        {isSimpleCosts ? (
          <CostsSliderContainer id={id} step={500} index={1} />
        ) : (
          <div>
            {hideExtra !== true && (
              <AibleStep
                id={id}
                bId={"continuousImpact"}
                message={
                  "What is the cost of underestimating vs overestimating " + (outcome ? outcome : " the Outcome") + "?"
                }
                isBreak={true}
                optionsHolder={false}
              />
            )}
            <div className={styles.wrapper + " " + styles.transitionHolder}>
              <div className={styles.contInput}>
                <div className={styles.rowLabelR}>
                  <div className={styles.topImpact} id="underestimateLabel">
                    <LineInput
                      value={underestimateLabel}
                      onChange={(val) => updateUnderestimateLabel(val)}
                      isLocked={isLocked}
                      isDisabled={noEdit}
                      isMediumBox
                    />
                  </div>
                  <div className={styles.botLabel}>{"Cost of Underestimate"}</div>
                </div>
                <div className={styles.cFlex}>
                  <LineInput
                    value={Math.abs(conversionCost)}
                    onChange={(val) => updateConversionCost(val)}
                    isMediumBox
                    inputType="float"
                    isLocked={isLocked}
                    isDisabled={noEdit}
                  />
                </div>
              </div>
              <div className={styles.contInput}>
                <div className={styles.rowLabelR}>
                  <div className={styles.topImpact} id="overestimateLabel">
                    <LineInput
                      value={overestimateLabel}
                      onChange={(val) => updateOverestimateLabel(val)}
                      isLocked={isLocked}
                      isDisabled={noEdit}
                      isMediumBox
                    />
                  </div>
                  <div className={styles.botLabel}>{"Cost of Overestimate"}</div>
                </div>
                <div className={styles.cFlex}>
                  <LineInput
                    value={Math.abs(conversionGain)}
                    onChange={(val) => updateConversionGain(val)}
                    isMediumBox
                    inputType="float"
                    isLocked={isLocked}
                    isDisabled={noEdit}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  render() {
    const {
      id,
      step,
      blueprintId,
      isAdvanced,
      isEditing,
      isShow,
      isSimpleCosts,
      customvalues,
      conversionGain,
      conversionCost,
      conversionSaved,
      conversionMissed,
      customValues,
      outcome,
      updateConversionGain,
      updateIsAdvanced,
      updateIsSimpleCosts,
      updateConversionCost,
      hideExtra
    } = this.props;

    const { isSlider, isSetup } = this.state;

    return (
      <div className={styles.body} style={hideExtra ? { paddingTop: "20px", paddingBottom: "0px" } : {}}>
        {this.renderNormal()}
        {hideExtra !== true && (
          <div className={styles.advancedBtn} style={{ paddingBottom: "0px" }}>
            <Button type="secondary" onClick={() => updateIsSimpleCosts(!isSimpleCosts)}>
              {isSimpleCosts ? "Show Advanced" : "I Don't Know"}
            </Button>
          </div>
        )}
        {/*
        <div className={styles.toggleHolder}>
          <Button type="secondary" onClick={() => this.setState({ isSlider: !isSlider })}>
            {isSlider ? "I Know Exact Impacts" : "I Know Estimates Only"}
          </Button>
        </div>
        */}
      </div>
    );
  }
}
